/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../icon/icon'

const EmptySvg = forwardRef((props, svgRef) => (
	<svg
		width={24}
		height={24}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fontSize="medium"
		ref={svgRef}
		{...props}
	/>
))
EmptySvg.displayName = 'EmptySvg'

const Empty = forwardRef((props, ref) => <Icon component={EmptySvg} ref={ref} {...props} />)
Empty.displayName = 'Empty'

Empty.defaultProps = { ...Icon.defaultProps }
Empty.propTypes = { ...Icon.propTypes }

export default Empty
export { EmptySvg }
